// 表格行、列表行只用这一种悬停底色和一种选中底色。
export const ROW_HOVER_CLASS = 'hover:bg-button-neutral'
export const ROW_SELECTED_CLASS =
  'bg-button-selected hover:bg-button-selected [&_.text-muted-foreground]:text-foreground'
/** 用 `data-state="selected"` 标出选中行的表格。 */
export const ROW_DATA_SELECTED_CLASS =
  'data-[state=selected]:bg-button-selected data-[state=selected]:hover:bg-button-selected data-[state=selected]:[&_.text-muted-foreground]:text-foreground'
/** 表格行尾的操作：悬停所在行（行带 `group`）或聚焦操作本身时才出现。 */
export const ROW_ACTIONS_REVEAL_CLASS =
  'opacity-0 transition-opacity focus-within:opacity-100 group-hover:opacity-100'
